import { implementSetAllNavTabDetailsMutation } from "../../../../dt-plugins/sidewindow/nav-tab";
import * as types from "./types";

export const templateMutations = {
  [types.SelectedBookingTemplate.SET.SINGLE] (state, payload) {
    state.templates = payload;
  },
  ...implementSetAllNavTabDetailsMutation(types.TemplateDetails, 'templateDetails'),
}